// extracted by mini-css-extract-plugin
export default {"approvalLoader":"AttestApprovalViewer_approvalLoader__sRUP8"};